export default __webpack_public_path__ + "locales/fr/JavascriptSdk.json?hash=a6b4a003572443fc381b5a2f1aac4391";